import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import {NgForm} from '@angular/forms';
import {ConstantsService} from '../../../../services/constants.service';
import {AdminService} from '../../../../services/admin.service';
import {Theme} from '../../../../types/admin-data.types';
import {CustomStyleService} from '../../../../services/custom-style.service';
import { environment } from 'environments/environment';
import {UrlService} from '../../../../services/url.service';
import {ApiClientService} from '../../../../services/api-client.service';
import { AuthTokenService } from '../../../../services/auth-token.service';

declare const $;
declare const swal;
declare const toastr;

@Component({
    selector: 'theme-modal',
    templateUrl: 'theme-modal.component.html',
    styleUrls: ['theme-modal.component.scss']
})
export class ThemeModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: Theme = new Theme();
    disabledSubmit = false;
    disabledFileInput = false;
    spinnerShow = {logo: false, miniLogo: false};

    constructor(
      public adm: AdminService,
      public api: ApiClientService,
      private customStyles: CustomStyleService,
      private http: Http,
      public urlService: UrlService,
      private authTokenService: AuthTokenService
    ) {
    }

    ngOnInit() {
        if (this.adm.themeInModal)
            this.data = JSON.parse(JSON.stringify(this.adm.themeInModal));
        this.initColorPickers();
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.adm.isShowThemeModal = false;
                    this.adm.themeInModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.adm.isShowThemeModal = false;
            this.adm.themeInModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            return;
        }

        const data: any = {
            name: form.value.name,
            logo: this.data.logo,
            settings: this.getSettingsFromForm(),
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.adm.api.patch('oauthUrl', `/api/v1/theme/${this.data.id}.json`, data).subscribe(
                (res) => {
                    if (+this.customStyles.getCurrentThemeId() === +res.id) {
                        this.customStyles.enableTheme(res);
                        this.data = res;
                    }
                    this.updateView('Theme successfully updated');
                },
                error => {
                    this.disabledSubmit = false;
                    this.adm.api.errorHandler(error, 'Edit theme failed');
                }
            );
        } else {
            this.adm.api.post('oauthUrl', '/api/v1/theme.json', data).subscribe(
                () => this.updateView('Theme successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.adm.api.errorHandler(error, 'Create theme failed');
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.adm.getThemes();
        this.form.reset();
        this.hideModal();
    }

    changeLogo(e, target: string) {
        if (this.disabledFileInput) return;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.spinnerShow[target] = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }
                this.data[target] = res.path;
                this.spinnerShow[target] = false;
                this.disabledFileInput = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.spinnerShow[target] = false;
                this.disabledFileInput = false;
            }
        );
    }

    removeLogo(e, target: string) {
        e.preventDefault();
        swal(ConstantsService.getSwalConfig('Remove Logo?', 'You want to delete Logo?'),
            () => {
                this.data[target] = '';
            }
        );
    }

    initColorPickers() {
        $('#body-bg').spectrum({
            color: this.data.colors.body,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.body = color.toHexString()
        });

        $('#primary-color').spectrum({
            color: this.data.colors.primary,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.primary = color.toHexString()
        });

        $('#primary-hover-color').spectrum({
            color: this.data.colors.primaryHover,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.primaryHover = color.toHexString()
        });

        $('#secondary-color').spectrum({
            color: this.data.colors.secondary,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.secondary = color.toHexString()
        });

        $('#menu-background-color').spectrum({
            color: this.data.colors.menuBackgroundColor,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.menuBackgroundColor = color.toHexString()
        });

        $('#menu-font-color').spectrum({
            color: this.data.colors.menuFontColor,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.menuFontColor = color.toHexString()
        });

        $('#selected-menu-item-font-color').spectrum({
            color: this.data.colors.selectedMenuItemFontColor,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.selectedMenuItemFontColor = color.toHexString()
        });
    }

    getSettingsFromForm() {
        const obj = {
            colors: {
                body: this.data.colors.body,
                primary: this.data.colors.primary,
                primaryHover: this.data.colors.primaryHover,
                secondary: this.data.colors.secondary,
                menuBackgroundColor: this.data.colors.menuBackgroundColor,
                menuFontColor: this.data.colors.menuFontColor,
                selectedMenuItemFontColor: this.data.colors.selectedMenuItemFontColor
            },
            miniLogo: this.data.miniLogo
        };

        return JSON.stringify(obj);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/admin/themes/modal/theme-modal.component.ts